import script from "./OrgNode.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgNode.vue?vue&type=script&setup=true&lang=js"

import "./OrgNode.vue?vue&type=style&index=0&id=dd62dc8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd62dc8a"]])

export default __exports__